function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1453 1453",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M723.1 55.2c-374 0-677.2 303.2-677.2 677.2s303.2 677.2 677.2 677.2 677.2-303.2 677.2-677.2S1097.1 55.2 723.1 55.2m310.5 976.7c-12.1 19.9-38.2 26.2-58.1 14-159-97.1-359.2-119.1-594.9-65.3-22.7 5.2-45.4-9.1-50.5-31.8-5.2-22.7 9-45.4 31.7-50.5 258-59 479.2-33.6 657.7 75.5 20 12.2 26.3 38.2 14.1 58.1m82.9-184.4c-15.3 24.9-47.8 32.7-72.6 17.4-182-111.9-459.5-144.3-674.8-79-27.9 8.4-57.4-7.3-65.9-35.2-8.4-27.9 7.3-57.4 35.2-65.8 245.9-74.6 551.7-38.5 760.7 90 24.9 15.3 32.7 47.8 17.4 72.6m7.1-192c-218.3-129.6-578.3-141.6-786.7-78.3-33.5 10.1-68.8-8.7-79-42.2-10.1-33.5 8.7-68.8 42.2-79 239.2-72.6 636.9-58.6 888.1 90.6 30.2 17.9 40 56.7 22.2 86.8-17.8 30-56.7 40-86.8 22.1",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotify);
export default __webpack_public_path__ + "static/media/spotify.83f34b38e87d322c24eef0a8869b1799.svg";
export { ForwardRef as ReactComponent };